/** The card's place line for an activity at a Hub, when no translation is passed. */
export const defaultAtHubText = (hubName: string) => `At ${hubName}`;

export interface CardLocation {
  isOnline?: boolean;
  isAtHome?: boolean;
  /** The Hub the activity runs at: its venue reads by the Hub's name. */
  hub?: { name: string } | null;
  city?: string | null;
}

export interface CardLocationTexts {
  online: string;
  atHome: string;
  atVenue: string;
  atHub: (hubName: string) => string;
}

/** A venue named by its Hub ("At Studio Rivoli"); undefined when the activity is not at a Hub. */
export function cardHubLabel(hub: CardLocation['hub'], atHub: CardLocationTexts['atHub']): string | undefined {
  return hub ? atHub(hub.name) : undefined;
}

/** A card's one location line: online, at home, else the venue by its Hub, its city, or the generic "At venue". */
export function cardLocationText({ isOnline, isAtHome, hub, city }: CardLocation, texts: CardLocationTexts): string {
  if (isOnline) return texts.online;
  if (isAtHome) return texts.atHome;
  return cardHubLabel(hub, texts.atHub) || city || texts.atVenue;
}
